export const IDLE = 'IDLE'
export const INITIALIZING = 'INITIALIZING'
export const INITIALIZED = 'INITIALIZED'
